import { ChartScatter } from "lucide-react"

import type { ComparisonPlotType } from "@/utils/comparisonPlot"
import { generateShortUUID } from "@/utils/id-generation/short-uuid"

import { ScatterConfigControls } from "./components/ScatterConfigControls"
import { ScatterPlot } from "./components/ScatterPlot"
import type {
  AnyComparisonPlotEntry,
  ComparisonPlotConfigOfType,
  ComparisonPlotEntry,
} from "./types"

const scatterPlotEntry: ComparisonPlotEntry = {
  type: "scatter",
  label: "Scatter",
  icon: <ChartScatter className="h-4 w-4" aria-hidden="true" />,
  defaultConfig: () => ({ id: generateShortUUID(), type: "scatter" }),
  ConfigControls: ScatterConfigControls,
  Plot: ScatterPlot,
}

// Ordered for the "+ New plot" menu. Add an entry to register a new plot type.
export const COMPARISON_PLOT_ENTRIES: AnyComparisonPlotEntry[] = [
  scatterPlotEntry,
]

export const PLOT_REGISTRY: {
  [K in ComparisonPlotType]: ComparisonPlotEntry<ComparisonPlotConfigOfType<K>>
} = {
  scatter: scatterPlotEntry,
}
